import styled from "styled-components";
import Image from "next/image";
import { PrivateJetTravelHeroSection } from "./PrivateJetTravelHeroSection";
import { PrivateJetTravelBenefit } from "./PrivateJetTravelBenefit";
import { PrivateJetTravelServices } from "./PrivateJetTravelServices";
import { PrivateJetTravelCardProgram } from "./PrivateJetTravelCardProgram";
import { PrivateJetTravelExplanation } from "./PrivateJetTravelExplanation";
import { MainFooter } from "../../Footer/MainFooter";
import { PATH_PUBLIC_IMAGES } from "@/config/images";

export function PrivateJetTravelNormal({ pageContent = {} }) {
	const { content = {} } = pageContent || {};
	return (
		<HomepageContainer>
			<PrivateJetTravelHeroSection banner={content?.banner} />
			<BodyContainer>
				<PrivateJetTravelExplanation what_is_private_jet_travel={content?.what_is_private_jet_travel} />
			</BodyContainer>
			<BodyContainer>
				<BodyContent>
					<PrivateJetTravelBenefit we_operate_differently={content?.we_operate_differently} />
				</BodyContent>
			</BodyContainer>
			<PrivateJetTravelServices the_royal_air_difference={content?.the_royal_air_difference} />
			<CardProgramWrapper>
				<CardProgramBgLeft>
					<Image
						src={PATH_PUBLIC_IMAGES.private_jet_travel_bg_left}
						alt=""
						fill
						style={{ objectFit: "cover", objectPosition: "right center" }}
					/>
				</CardProgramBgLeft>
				<CardProgramBgRight>
					<Image
						src={PATH_PUBLIC_IMAGES.private_jet_travel_bg_right}
						alt=""
						fill
						style={{ objectFit: "cover", objectPosition: "left center" }}
					/>
				</CardProgramBgRight>
				<BodyContainer>
					<BodyContent>
						<PrivateJetTravelCardProgram jet_card_program={content?.jet_card_program} />
					</BodyContent>
				</BodyContainer>
			</CardProgramWrapper>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const CardProgramWrapper = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	justify-content: center;
	background: linear-gradient(180deg, #fff 0%, #dbe0e5 100%);
`;

const CardProgramBgLeft = styled.div`
	position: absolute;
	top: 100px;
	left: 0;
	width: 24%;
	height: 425px;
	pointer-events: none;

	@media (max-width: 1199px) {
		top: 80px;
		width: 30%;
	}

	@media (max-width: 991px) {
		width: 24%;
	}
`;

const CardProgramBgRight = styled.div`
	position: absolute;
	top: 100px;
	right: 0;
	width: 24%;
	height: 425px;
	pointer-events: none;

	@media (max-width: 1599px) {
		width: 28%;
	}

	@media (max-width: 1199px) {
		top: 80px;
		width: 36%;
	}

	@media (max-width: 991px) {
		width: 24%;
	}
`;

const BodyContainer = styled.div`
	max-width: 1442px;
	padding: 84px 136px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 90px 80px 0px 80px;
	}
	@media (max-width: 767px) {
		padding: 60px 32px 0px 32px;
	}
	@media (max-width: 575px) {
		padding: 40px 20px 0px 20px;
	}
`;

const BodyContent = styled.div`
	@media (max-width: 991px) {
		padding-bottom: 90px;
	}
	@media (max-width: 767px) {
		padding-bottom: 60px;
	}
	@media (max-width: 575px) {
		padding-bottom: 40px;
	}
`;

const BodyExperienceContainer = styled.div`
	width: 100%;
	background-image: url("/images/private-jet-travel/private-jet-travel-mask.png");
	display: flex;
	justify-content: center;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	margin: 84px 0px;
	@media (max-width: 991px) {
		margin: 72px 0px;
	}
	@media (max-width: 767px) {
		margin: 52px 0px;
	}
	@media (max-width: 575px) {
		margin: 40px 0px;
		background-image: url("/images/private-jet-travel/private-jet-travel-mask-mobile.png");
	}
`;

const LayoutOverlay = styled.div`
	width: 100%;
	height: 100%;
	background: rgba(249, 249, 249, 0);
	display: flex;
	justify-content: center;
`;
